/* RN brand v5 shop layer: collection title accent, and Ripley the mascot, who carries a tagged parcel to the basket and sometimes perches. */
(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const R = (a, b) => a + Math.random() * (b - a);

  // Collection title: italic petrol last word. Hyper keeps a hidden "Collection:" label inside the h1.
  const h1 = document.querySelector('.collection-hero__info .collection-hero__title');
  if (h1 && !h1.dataset.rn) { h1.dataset.rn = 1;
    const tw = document.createTreeWalker(h1, NodeFilter.SHOW_TEXT); let tn = null;
    while (tw.nextNode()) if (tw.currentNode.nodeValue.trim() && !tw.currentNode.parentElement.closest('.visually-hidden')) tn = tw.currentNode;
    const m = tn && tn.nodeValue.match(/^([\s\S]*\S\s+)(\S+)(\s*)$/);
    if (m) { const s = document.createElement('span'); s.className = 'rn-acc'; s.textContent = m[2]; tn.nodeValue = m[1]; tn.after(s, m[3]); }
  }

  // Ripley. One sprite leaves the header, carries a piece to the basket or perches for a moment, then flies home.
  // He never fades: if the header is out of sight he flies off the edge of the screen instead.
  // Purely decorative: pointer-events none, the add to basket request is never delayed, any scroll or tap sends a perched bird away.
  const logo = document.querySelector('[data-rn-flap]'), frames = logo ? logo.dataset.rnFlap.split('|') : [];
  const P = logo && logo.dataset.rnPerch ? logo.dataset.rnPerch.split('|') : []; // perch, look, preen, stretch, brake, crouch
  const tagSrc = logo && logo.dataset.rnTag;
  const rip = window.rnRipley, S = matchMedia('(max-width: 749px)').matches ? 44 : 56;
  const target = () => [...document.querySelectorAll('.cart-drawer-button')].find(a => a.getBoundingClientRect().width > 0);
  const bump = to => { to.classList.remove('rn-cart-bump'); void to.offsetWidth; to.classList.add('rn-cart-bump'); };
  const bz = (a, c, b, k) => (1 - k) * (1 - k) * a + 2 * (1 - k) * k * c + k * k * b, io = t => t < .5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
  const wait = ms => new Promise(r => setTimeout(r, ms));
  const homeVisible = () => { const r = rip && rip.rect(); return r && r.width && r.bottom > 0 && r.top < innerHeight; };
  const homeC = () => { const r = rip.rect(); return [r.left + r.width / 2, r.top + r.height / 2, r.width / S]; };
  const offC = () => [innerWidth + S * 1.5, -S * 1.2, .8];

  let sp = null, job = 0, mode = '';
  const pose = (x, y, s, dir, rot) => { Object.assign(sp, { x, y, s, dir }); sp.w.style.transform = `translate3d(${x - S / 2}px,${y - S / 2}px,0) scale(${dir * s},${s}) rotate(${rot || 0}deg)`; };
  const quiet = () => { sp.img._rnIdle = (sp.img._rnIdle || 0) + 1; sp.img.getAnimations().forEach(a => a.cancel()); };
  const show = src => { if (src && sp.img.getAttribute('src') !== src) sp.img.src = src; };
  const make = () => {
    if (sp) return;
    const w = document.createElement('div'); w.className = 'rn-fly'; w.setAttribute('aria-hidden', 'true');
    const img = new Image(); img.src = frames[0]; img.alt = ''; img.dataset.rnFlap = frames.join('|'); w.appendChild(img); document.body.appendChild(w);
    sp = { w, img }; const [x, y, s] = homeVisible() ? homeC() : offC(); pose(x, y, s, 1); rip && rip.leave();
  };
  // Curved flight from wherever he is to a live target (re-read every frame, so scrolling never strands him).
  const travel = (id, getB, dur, lift, s1, onStep) => new Promise(res => {
    quiet(); const x0 = sp.x, y0 = sp.y, s0 = sp.s, t0 = performance.now(); let lf = 0, f = 0;
    const step = now => {
      if (id !== job) return res(false);
      const [bx, by] = getB(), k = io(Math.min(1, (now - t0) / dur)), dir = bx < x0 - 2 ? -1 : 1;
      const x = bz(x0, (x0 + bx) / 2, bx, k), y = bz(y0, Math.min(y0, by) - lift, by, k), s = s0 + (s1 - s0) * k;
      pose(x, y, s, dir, -7 * Math.sin(k * Math.PI));
      if (now - lf > 70) { lf = now; f = (f + 1) % frames.length; show(frames[f]); }
      onStep && onStep(x, y, s, now, dir);
      if (k < 1) requestAnimationFrame(step); else { show(frames[0]); res(true); }
    };
    requestAnimationFrame(step);
  });
  // Stay put on a moving target.
  const hold = (id, getP, ms) => new Promise(res => {
    const t0 = performance.now();
    const step = now => { if (id !== job) return res(false); const p = getP(); pose(p[0], p[1], sp.s, sp.dir); if (now - t0 < ms) requestAnimationFrame(step); else res(true); };
    requestAnimationFrame(step);
  });
  // Landing: wings flare to brake, feet take the weight with a small squash, then the wing folds down.
  const land = async id => {
    if (P.length) { show(P[4]); await wait(180); if (id !== job) return; }
    show(P[0] || frames[2]);
    sp.img.animate([{ transform: 'translateY(-6%)' }, { transform: 'scale(1.08,.9)' }, { transform: 'none' }], { duration: 260, easing: 'cubic-bezier(.3,1.4,.5,1)' });
  };
  // Take-off: crouch low over the feet, then go.
  const crouch = async () => { if (!P.length || !sp) return; quiet(); show(P[5]); await wait(170); };
  // Perched idles from the real poses: head bob, look, preen under the wing, wing stretch.
  const idle = async id => {
    const k = Math.random(), ok = () => id === job && mode === 'perch';
    if (!P.length) return rip && rip.idle(sp.img);
    if (k < .35) { show(P[1]); await wait(R(700, 1200)); if (ok()) show(P[0]); }
    else if (k < .7) { show(P[1]); await wait(140); if (!ok()) return; show(P[2]); await wait(R(900, 1400)); if (!ok()) return; show(P[1]); await wait(160); if (ok()) show(P[0]); }
    else if (k < .88) { show(P[3]); await wait(R(500, 750)); if (ok()) show(P[0]); }
    else sp.img.animate([{ transform: 'none' }, { transform: 'translateY(4%) scale(1.03,.96)' }, { transform: 'none' }], { duration: 300, iterations: 2 });
  };
  const perchHold = (id, getP, ms) => new Promise(res => {
    const t0 = performance.now(); let next = t0 + R(900, 1500);
    const step = now => {
      if (id !== job) return res(false);
      const p = getP(); pose(p[0], p[1], sp.s, sp.dir);
      if (now > next) { next = now + R(2600, 4200); idle(id); }
      if (now - t0 < ms) requestAnimationFrame(step); else res(true);
    };
    requestAnimationFrame(step);
  });
  const goHome = async id => {
    if (!sp) return;
    if (mode === 'perch' || mode === 'help') await crouch();
    mode = 'home'; if (id !== job) return;
    const home = homeVisible();
    if (!await travel(id, home ? homeC : offC, home ? 720 : 900, 36, home ? homeC()[2] : .8)) return;
    sp.w.remove(); sp = null; mode = ''; rip && rip.land();
  };

  const fly = async from => {
    const to = target(); if (!to || !frames.length) return;
    if (reduce || mode === 'carry') return bump(to);
    const id = ++job; make(); mode = 'carry';
    // A paper parcel tag on a short string, held in the beak.
    const item = document.createElement('div'); item.className = 'rn-fly-item'; item.setAttribute('aria-hidden', 'true');
    item.innerHTML = tagSrc ? `<img src="${tagSrc}" alt="">` : '<i></i><b></b>';
    document.body.appendChild(item);
    let sw = 0, px = 0;
    const carry = (x, y, s, now, dir) => { const v = x - px; px = x; sw += (Math.max(-24, Math.min(24, -v * 2.2)) - sw) * .18;
      item.style.transform = `translate3d(${x + (dir || 1) * S * .3 * s}px,${y - S * .02 * s}px,0) scale(${s}) rotate(${sw}deg)`; };
    const above = () => { const r = from.getBoundingClientRect(); return [r.left + r.width / 2, Math.max(S / 2 + 8, r.top - S * .5)]; };
    const basket = () => { const r = to.getBoundingClientRect(); return [r.left + r.width / 2, r.top + r.height / 2]; };
    const done = () => item.remove();
    if (!await travel(id, above, 520, 24, 1)) return done();
    const [ax, ay] = above(); px = ax; carry(ax, ay, 1, 0, sp.dir); item.classList.add('is-got');
    if (!await hold(id, above, 160)) return done();
    const ok = await travel(id, basket, 820, 60, .6, carry);
    if (!ok) return done();
    const [bx, by] = basket();
    item.animate([{ transform: item.style.transform }, { transform: `translate3d(${bx}px,${by}px,0) scale(.2)` }], { duration: 180, easing: 'ease-in' }).onfinish = done;
    bump(to);
    await hold(id, basket, 160);
    goHome(id);
  };
  document.addEventListener('click', e => { const b = e.target.closest('.product-form__submit,button.product-card__atc,.sticky-atc-bar button[type=submit]');
    if (!b || b.disabled || b.getAttribute('aria-disabled') === 'true') return;
    // A required custom field is empty: the browser blocks the add, so no parcel to carry.
    const form = b.form || b.closest('form'); if (form && [...form.elements].some(el => el.willValidate && !el.validity.valid)) return;
    fly(b); }, true);
  // Required fields stop the submit before the theme sees it, so pick up the browser's own invalid event
  // (first field only) and hand it to the field help below.
  let lastInvalid = 0;
  document.addEventListener('invalid', e => { const el = e.target;
    if (!el.closest || !el.closest('[data-rn-personalisation]')) return;
    // The field shows its own message in words, so skip the browser's tooltip that would repeat it.
    e.preventDefault();
    if (performance.now() - lastInvalid < 800) return;
    lastInvalid = performance.now(); el.focus({ preventScroll: true });
    el.dispatchEvent(new CustomEvent('rn:personalisation-invalid', { bubbles: true, detail: { input: el } }));
    const f = el.closest('.rn-field') || el; f.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); }, true);
  window.rnFly = fly;

  // Perching: when the visitor pauses, Ripley lands on the add to basket button (product page) or a product
  // picture, preens, then goes. Twice a page at most; never while scrolling.
  const inView = el => { const r = el.getBoundingClientRect(); return r.width > 0 && r.top > 110 && r.bottom < innerHeight - 90; };
  const perch = () => {
    const btn = [...document.querySelectorAll('.product-form__submit')].find(el => inView(el) && !el.disabled);
    if (btn) return () => { const r = btn.getBoundingClientRect(); return [r.right - S * .5, r.top - S * .31]; };
    const pic = [...document.querySelectorAll('.product-card__image-wrapper')].find(inView);
    if (pic) return () => { const r = pic.getBoundingClientRect(); return [r.left + r.width * .24, r.top - S * .31]; };
  };
  let visits = 0, stillSince = performance.now(), nextVisit = 0;
  const visit = async () => {
    const Pt = perch(); if (!Pt) return;
    visits++; nextVisit = performance.now() + 40000; const id = ++job; make(); mode = 'perch';
    if (!await travel(id, Pt, 900, 46, 1)) return;
    await land(id);
    if (!await perchHold(id, Pt, 9000)) return;
    goHome(id);
  };
  // Custom field still empty when Add to basket is pressed: the field gets a petrol ring and Ripley lands on it.
  // He leaves once they start typing or after a few seconds. Scrolling to the field does not send him away.
  document.addEventListener('rn:personalisation-invalid', async e => {
    const input = e.detail && e.detail.input; if (!input) return;
    const f = input.closest('.rn-field') || input.parentElement; if (f.classList.contains('rn-needs')) return; f.classList.add('rn-needs');
    const tgt = f.querySelector('.form-control') || input;
    let id = 0;
    const off = () => { f.classList.remove('rn-needs'); if (id && id === job && mode === 'help') goHome(++job); };
    input.addEventListener('input', off, { once: true }); input.addEventListener('change', off, { once: true });
    if (reduce || !frames.length || !rip) return;
    const Pt = () => { const r = tgt.getBoundingClientRect(); return [r.right - S * .6, r.top - S * .31]; };
    id = ++job; make(); mode = 'help';
    if (!await travel(id, Pt, 820, 40, 1)) return;
    await land(id);
    if (!await hold(id, Pt, 600)) return;
    if (P.length) show(P[1]);
    if (!await hold(id, Pt, 900)) return;
    if (P.length) show(P[0]);
    if (await hold(id, Pt, 6000)) goHome(id);
  });

  const recall = () => { stillSince = performance.now(); if (sp && mode === 'perch') goHome(++job); };
  if (!reduce && frames.length && rip) {
    addEventListener('scroll', recall, { passive: true });
    addEventListener('pointerdown', recall, { passive: true });
    addEventListener('keydown', recall, { passive: true });
    setInterval(() => { const now = performance.now();
      if (visits < 2 && !sp && !document.hidden && !rip.isBusy() && !rip.isAway() && now - stillSince > 6000 && now > nextVisit) visit(); }, 1000);
  }
})();

/* Phones: the shop chat bubble never sits on an add to basket button. Above the sticky bar it lifts clear;
   while the button in the page is underneath it, it steps aside and comes back as soon as the button moves on. */
(() => {
  const phone = matchMedia('(max-width: 749px)');
  let chat = null, base = null, queued = false;
  const bubble = () => {
    if (!chat.shadowRoot) return null;
    const r = [...chat.shadowRoot.querySelectorAll('*')].map(e => e.getBoundingClientRect()).find(r => r.width > 30 && r.width < 200 && r.height > 20 && r.height < 90);
    return r ? { top: r.top, bottom: r.bottom, left: r.left, right: r.right } : null;
  };
  const hits = (a, b) => a.left < b.right && a.right > b.left && a.top < b.bottom && a.bottom > b.top;
  const place = () => {
    queued = false;
    if (!chat) return;
    if (!phone.matches) { chat.style.transform = chat.style.opacity = chat.style.pointerEvents = ''; return; }
    if (!base) { chat.style.transform = ''; base = bubble(); }
    // Sticky bar showing: always lift by its height, even when the bubble can't be measured (real phones).
    const sb = document.querySelector('.rn-pbar.is-on') || document.querySelector('.sticky-atc-bar'), sr = sb && sb.getBoundingClientRect();
    const barUp = sb && getComputedStyle(sb).visibility !== 'hidden' && sr.height && sr.top < innerHeight - 4;
    if (!base) { chat.style.transform = barUp ? `translateY(${-Math.round(innerHeight - sr.top + 12)}px)` : ''; return; }
    let lift = 0, hide = false;
    document.querySelectorAll('.product-form__submit, .sticky-atc-bar button[type=submit]').forEach(btn => {
      const r = btn.getBoundingClientRect(); if (!r.width || getComputedStyle(btn).visibility === 'hidden') return;
      if (!hits(base, r)) return;
      if (btn.closest('.sticky-atc-bar')) lift = Math.max(lift, base.bottom - r.top + 10);
      else hide = true;
    });
    // Words and links the bubble must never sit on: step aside while they pass underneath.
    if (!hide) document.querySelectorAll('.rnh-proof a, .rnh-cta, [data-rn-chat-clear]').forEach(el => {
      const r = el.getBoundingClientRect(); if (r.width && hits(base, r)) hide = true;
    });
    if (barUp) lift = Math.max(lift, base.bottom - sr.top + 12, innerHeight - sr.top + 12);
    chat.style.transition = 'transform .25s ease, opacity .2s ease';
    chat.style.transform = lift ? `translateY(${-Math.round(lift)}px)` : '';
    chat.style.opacity = hide ? '0' : '';
    chat.style.pointerEvents = hide ? 'none' : '';
  };
  const queue = () => { if (!queued) { queued = true; requestAnimationFrame(place); } };
  const find = () => { chat = document.querySelector('shopify-chat'); if (chat) { base = null; setTimeout(queue, 600); } return !!chat; };
  if (!find()) { const mo = new MutationObserver(() => { if (find()) mo.disconnect(); }); mo.observe(document.documentElement, { childList: true, subtree: true }); setTimeout(() => mo.disconnect(), 20000); }
  // The sticky bar slides in a moment after the scroll that reveals it, so look again once scrolling settles.
  let settle = 0;
  addEventListener('scroll', () => { queue(); clearTimeout(settle); settle = setTimeout(queue, 450); }, { passive: true });
  addEventListener('resize', () => { base = null; queue(); });
})();

/* Personalised pieces on phones: the buy button sits under a long form, so a quiet bar takes them to the form, then to the button. */
(() => {
  const form = document.querySelector('.rn-personalisation:not(.rn-personalisation--configuration-error)');
  if (!form) return;
  const phone = matchMedia('(max-width: 749px)'), smooth = !matchMedia('(prefers-reduced-motion: reduce)').matches;
  const submit = (form.closest('form') && form.closest('form').querySelector('[type=submit]')) || document.querySelector('.product-form__submit');
  const price = () => { const e = [...document.querySelectorAll('.product__block--price .f-price-item--sale, .product__block--price .f-price-item--regular')].find(e => e.offsetParent && e.textContent.trim()); return e ? e.textContent.trim() : ''; };
  const bar = document.createElement('div');
  bar.className = 'rn-pbar';
  bar.innerHTML = '<span class="rn-pbar__price"></span><button type="button" class="rn-pbar__go"></button>';
  document.body.appendChild(bar);
  const go = bar.querySelector('button');
  let toForm = true, q = false;
  go.addEventListener('click', () => {
    const t = toForm ? form : submit;
    scrollTo({ top: t.getBoundingClientRect().top + scrollY - (toForm ? 90 : innerHeight * .45), behavior: smooth ? 'smooth' : 'auto' });
  });
  const upd = () => {
    q = false;
    const fr = form.getBoundingClientRect(), sr = submit ? submit.getBoundingClientRect() : fr;
    const typing = form.contains(document.activeElement) && /INPUT|TEXTAREA|SELECT/.test(document.activeElement.tagName) && document.activeElement.type !== 'file';
    const btnVisible = sr.top < innerHeight && sr.bottom > 0;
    toForm = fr.top > innerHeight * .6 || sr.bottom < 0;
    go.textContent = toForm ? 'Personalise yours' : 'Continue to basket';
    bar.firstChild.textContent = price();
    bar.classList.toggle('is-on', phone.matches && form.offsetParent !== null && !btnVisible && !typing && scrollY > 150);
  };
  const qu = () => { if (!q) { q = true; requestAnimationFrame(upd); } };
  addEventListener('scroll', qu, { passive: true }); addEventListener('resize', qu);
  ['change', 'focusin', 'focusout'].forEach(e => document.addEventListener(e, qu));
  qu();
})();


/* p20: the navigation drawer is a modal, not an unlabelled generic container.
   Own only this drawer's keyboard boundary; preserve the theme's open/hide lifecycle. */
(() => {
  const initMenuAccessibility = () => {
    const drawer = document.getElementById('MenuDrawer');
    if (!drawer || drawer.dataset.rnA11yMenuReady) return;
    drawer.dataset.rnA11yMenuReady = 'true';
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-label', 'Main menu');
    drawer.setAttribute('aria-modal', 'true');
    let opener = null;
    const focusable = () => Array.from(drawer.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),summary,[tabindex]:not([tabindex="-1"])'))
      .filter(el => !el.closest('[hidden],[inert]') && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden'
        && !Array.from(drawer.querySelectorAll('details:not([open])')).some(d => d.contains(el) && el !== d.querySelector('summary')));
    const focusFirst = () => {
      if (!drawer.hasAttribute('open') || drawer.hidden) return;
      const first = focusable()[0];
      if (first) first.focus({ preventScroll: true });
      else { drawer.setAttribute('tabindex', '-1'); drawer.focus({ preventScroll: true }); }
    };
    new MutationObserver(records => {
      if (!records.some(r => r.attributeName === 'open')) return;
      if (drawer.hasAttribute('open')) {
        opener = document.activeElement;
        requestAnimationFrame(() => requestAnimationFrame(focusFirst));
      } else if (opener && opener.isConnected) {
        opener.focus({ preventScroll: true });
      }
    }).observe(drawer, { attributes: true, attributeFilter: ['open'] });
    drawer.addEventListener('keydown', event => {
      if (!drawer.hasAttribute('open') || event.key !== 'Tab') return;
      const items = focusable(), first = items[0], last = items[items.length - 1];
      const current = document.activeElement;
      if (!first) { event.preventDefault(); event.stopImmediatePropagation(); focusFirst(); return; }
      if (!drawer.contains(current) || (event.shiftKey && (current === first || current === drawer)) || (!event.shiftKey && current === last)) {
        event.preventDefault(); event.stopImmediatePropagation();
        (event.shiftKey ? last : first).focus();
      }
    }, true);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initMenuAccessibility, { once: true });
  else initMenuAccessibility();
})();

/* Partner links: ?ref=<code> on any page is remembered for 60 days on this device and saved on the
   basket as the order detail "Partner". No discount and nothing is shown to the buyer. The last link
   opened wins. A code is 2 to 40 characters: lowercase letters, digits and hyphens. */
(() => {
  const KEY = 'rn_partner';
  const MAX_AGE = 60 * 864e5;
  const clean = (value) => {
    const code = String(value || '').trim().toLowerCase();
    return /^[a-z0-9][a-z0-9-]{1,39}$/.test(code) ? code : '';
  };
  let saved = null;
  try { saved = JSON.parse(window.localStorage.getItem(KEY) || 'null'); } catch (e) {}
  let fromLink = '';
  try { fromLink = clean(new URLSearchParams(window.location.search).get('ref')); } catch (e) {}
  if (fromLink) saved = { code: fromLink, at: Date.now() };
  if (!saved || !clean(saved.code) || Date.now() - Number(saved.at || 0) > MAX_AGE) {
    try { window.localStorage.removeItem(KEY); } catch (e) {}
    return;
  }
  try { window.localStorage.setItem(KEY, JSON.stringify(saved)); } catch (e) {}
  const save = () => fetch('/cart/update.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ attributes: { Partner: saved.code } })
  }).catch(() => {});
  /* The basket is replaced after each order, so check it on every page rather than trusting a flag. */
  const sync = () => fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
    .then((response) => response.json())
    .then((cart) => { if (!cart.attributes || cart.attributes.Partner !== saved.code) return save(); })
    .catch(() => {});
  window.rnPartnerReady = sync();
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (form && form.matches && form.matches('form[action*="/cart"]') && !form.querySelector('input[name="attributes[Partner]"]')) {
      const input = document.createElement('input');
      input.type = 'hidden'; input.name = 'attributes[Partner]'; input.value = saved.code;
      form.appendChild(input);
    }
  }, true);
})();
